import script from "./filters.vue?vue&type=script&setup=true&lang=js"
export * from "./filters.vue?vue&type=script&setup=true&lang=js"

import "./filters.vue?vue&type=style&index=0&id=76541cfc&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76541cfc"]])

export default __exports__